import React from "react";
import ReactModal from "react-modal";

import { ReactComponent as CloseIcon } from "assets/img/close.svg";
import styles from "./ExpandedInlineImage.module.scss";

const ExpandedInlineImage = (
    { imageSrc, showComponent, setShowComponent, isCommentComponent, originalFileName }:
        {
            imageSrc: string,
            showComponent: boolean,
            setShowComponent: (showComponent: boolean) => void,
            isCommentComponent: boolean,
            originalFileName?: string
        }
) => {

    let filenameWithExtension
    if (isCommentComponent) {
        const parts = imageSrc.split("/");
        const postPart = parts[parts.length - 1];
        const postPartParts = postPart.split("?");
        const filename = postPartParts[0];
        const fileNameWithoutPostString = filename.split("_");
        const newString = fileNameWithoutPostString[fileNameWithoutPostString.length - 1];
        filenameWithExtension = decodeURI(newString.replace(/[^\w\s.-]/gi, " "));
    } else {
        filenameWithExtension = originalFileName && originalFileName.replace(/[^\w\s.-]/gi, " ")
    }

    return (
        <ReactModal
            isOpen={showComponent}
            style={{
                content: {
                    width: "98%",
                    height: "97%",
                    borderRadius: '8px',
                    top: "50%",
                    left: "50%",
                    right: "auto",
                    bottom: "auto",
                    transform: "translate(-50%, -50%)",
                    position: "fixed",
                    border: 0,
                    overflow: "hidden",
                    padding: 0,
                    margin: 0,
                    backgroundColor: 'white',
                },
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 2147483647,
                    padding: 0,
                    margin: 0,
                }
            }}
        >
     <div className={styles.modalContainer}>
        <div className={styles.header}>
          <span className={styles.filename}>
            {filenameWithExtension}
          </span>

          <span
            className={styles.closeButton}
            onClick={() => setShowComponent(false)}
          >
            <CloseIcon />
          </span>
        </div>

        <span className={styles.divider} />

        <div className={styles.imageContainer}>
          <img
            src={imageSrc}
            alt="inline expanded"
            className={styles.image}
          />
        </div>
      </div>
        </ReactModal >
    )
}

export default ExpandedInlineImage